<template>
	<div>
		<div class="wrapper">
			<!-- 서브 헤더 --------- start -->
			<v-layout wrap class="mb-2" align-center>
				<v-icon color="#9D9DB7">
					mdi-circle-small
				</v-icon>
				<span class="sub_header">마케팅DB 관리</span>
			</v-layout>
			<!-- 서브 헤더 ----------- end -->

			<v-layout align-center class="header_search">
				<v-layout class="search_wrap">
					<v-layout>
						<v-flex class="search_select_type ml-4" style="width:300px; max-width:300px;">
							<selectBox :sel="surveySel" class="searchSel" @change="search_reservedays()"></selectBox>
						</v-flex>
					</v-layout>

					<!-- 날짜 선택 --------- start -->
					<v-layout justify-end>
						<!-- <v-flex :class="$vuetify.breakpoint.smAndDown ? 'my-2' : 'search_date_1'">
							<DatepickerDialog :picker="termStartpicker"></DatepickerDialog>
						</v-flex>
						<span class="mx-1"> ~ </span>
						<v-flex :class="$vuetify.breakpoint.smAndDown ? 'my-2 ' : 'search_date_2'">
							<DatepickerDialog :picker="termEndpicker" :allowed_dates="termCustomer"> </DatepickerDialog>
						</v-flex>
						<v-flex class="search_select ml-4" style="width:120px !important; max-width:120px !important;">
							<selectBox :sel="searchsel" @change="selectDays" :class="'searchSel'"></selectBox>
						</v-flex> -->
						<!-- 날짜 선택 --------- end -->
						<!-- <v-flex class="search_select ml-4" style="width:120px !important; max-width:120px !important;">
							<selectBox :sel="filterTag" @change="changeTester" :class="'searchSel'"></selectBox>
						</v-flex> -->
						<!-- 이름 검색 start  -->
						<v-flex md4 sm4 xs12>
							<txtField
								class="search_box_type"
								v-model="search_keyword"
								:txtField="search"
								ref="search_input"
								@keyup.enter="
									() => {
										first = false
										getTableData(surveySel.value, null, { title_contains: search_keyword })
									}
								"
							></txtField>
						</v-flex>

						<v-btn
							class="search_btn"
							color="#ff9419"
							@click="
								() => {
									first = false
									getTableData(surveySel.value, null, { title_contains: search_keyword })
								}
							"
							><v-icon>mdi-magnify</v-icon>조회</v-btn
						>
						<!-- 이름 검색 end  -->
					</v-layout>
				</v-layout>
			</v-layout>

			<!-- --- 데이터 테이블 -------- start -->
			<v-layout wrap>
				<!-- 테이블 -->
				<v-flex xs12>
					<datatable
						:datatable="table.datatable"
						class="tbl-type01"
						:detailClick="detailClick"
						@pagination="pagination"
						excelRoute="marketingDB"
						@codeCopy="codeCopy"
					>
					</datatable>
				</v-flex>
			</v-layout>
			<!-- --- 데이터 테이블 -------- end -->
		</div>

		<!-- 신규 등록 버튼 -->
		<v-layout justify-start align-items-center class="left_minus_margin">
			<btn
				:btn="addBtn"
				:class="'small_action_btn'"
				:style="`background-color:${$store.state.PointColor2}`"
				:btn_txt="'신규등록'"
				@click="addButtonClick()"
			></btn>
		</v-layout>

		<!-- 생성 / 수정 팝업 -->
		<editMarketingDBModal
			ref="DB_modal"
			:setdialog="detail_dialog"
			:validation_chceck="validation_chceck"
			:open_disable_dialog="open_disable_dialog"
			:activeDelete="activeDelete"
		/>

		<!-- 저장 확인 팝업 -->
		<sweetAlert :dialog="sweetDialog" />
		<!-- 저장 불가 팝업 -->
		<sweetAlert :dialog="sweetInfo" />
	</div>
</template>

<script>
import { datatable, selectBox, sweetAlert, txtField, btn, editMarketingDBModal } from '@/components/index.js'
export default {
	components: {
		datatable,
		selectBox,
		txtField,
		sweetAlert,
		btn,
		editMarketingDBModal,
	},
	props: {
		nowTabs: Number,
		tabIdx: Number,
	},
	// watch: {
	// 	nowTabs: {
	// 		deep: true,
	// 		async handler() {
	// 			if (this.nowTabs === this.tabIdx) {
	// 				await this.getTableData(this.surveySel.value)
	// 			}
	// 		},
	// 	},
	// },
	data() {
		return {
			type: '',
			surveySel: {
				// 사업지 선택 셀렉트 박스
				value: '',
				errorMessage: '',
				hideDetail: true,
				items: [],
				fullItem: [],
				outlined: true,
				filter: true,
				label: '',
				returnObject: true,
				itemText: 'title',
			},
			// --- 데이터 테이블 데이터 --
			table: {
				datatable: {
					headers: [
						{ text: 'No.', value: 'No_index', width: '5%', sortable: false },
						{ text: '프로젝트 명', value: 'business_title', width: '15%', sortable: false },
						{ text: '마케팅 DB 명', value: 'title', width: '15%', sortable: false },
						{ text: '등록일', value: 'created_at_second', width: '13%', sortable: false },
						{ text: '추출 항목', value: 'itemList', sortable: false },
						{ text: '추출 DB 수량', value: 'number_comma', width: '12%', sortable: false },
						{
							text: '비고',
							align: 'center',
							value: 'etc_detail',
							width: '270px',
							sortable: false,
						},
					],
					items: [],
					hidedefaultfooter: false,
					noweditting: '',
					// title: x.name,
					onlyAgree: false,
					// inputboxId: x.id,
				},
				filter: [],
				json_fields: {},
			},

			// 날짜/검색 데이터
			searchsel: {
				// 날짜 선택 셀렉트 박스 - 오늘 , 이번주 , 이번달
				value: '오늘',
				errorMessage: '',
				hideDetail: true,
				items: ['오늘', '이번 주', '이번 달'],
				outlined: true,
			},

			search_keyword: '', // 검색창 인풋 value
			search: {
				// 검색창 텍스트필드
				placeholder: '검색어를 입력해주세요.',
				maxlength: '255',
				outlined: true,
				backCol: 'white',
			},

			termStartpicker: {
				// datePicker
				date: this.$moment().format('YYYY-MM-DD'),
				errorMessage: '',
				class: 'whiteBack defalut-date-picker-setting',
				menu: false,
			},

			termEndpicker: {
				// datePicker
				date: this.$moment().format('YYYY-MM-DD'),
				errorMessage: '',
				class: 'whiteBack defalut-date-picker-setting',
				menu: false,
			},

			addBtn: {
				// 추가 버튼
				dark: true,
				width: 100,
			},

			detail_dialog: {
				// 등록/수정 팝업 데이터
				dialog: false,
				type: 'create',
				id: null,
				disable_input: false,
				bizItems: [], // 좌측 프로젝트 선택용 아이템
				workingBusiness: {}, // 현재 수집항목 작업을 위해 선택된 비지니스
				campaigns: [], // 현재 수집항목 캠페인 리스트
				campaigns_added: [], // 추가중인 캠페인 리스트
				campaign_summary: [], // 선택된 프로젝트별 캠페인 요약 정보 json
				campaign_summary_index: 0, // 현재 보고있는 추출된 DB 인덱스
				banDB: [
					{ label: 'label1', check: false, id: 1 },
					{ label: 'label2', check: false, id: 2 },
				], // 제외DB 리스트
				deleteScheduled: false, // 삭제 예정 여부
				deleteAt: null, // 삭제 예정일

				banYear: [], // 제외DB 기간 리스트
				banDBParams: { banDB: [], banYear: [], banFile: [] },
				collectDB_added: [], // 수집DB 리스트
				banDB_added: [], // 제외DB 제외된 리스트
				items: [
					{
						title: '프로젝트',
						id: 'title',
						type: 'selectBox',
						selectBox: {
							value: '',
							errorMessage: '',
							hideDetail: true,
							items: [],
							outlined: true,
							filter: true,
							class: 'small_font bizInput',
							returnObject: true,
							itemText: 'title',
						},
					},

					{
						title: 'DB명',
						type: 'txtfield',
						value: '',

						txtfield: {
							maxlength: '255',
							outlined: true,
							hideDetail: true,
							errorMessage: '',
							autocomplete: 'off',
							readonly: false,
							append_close: true,
						},
					},
					{
						title: 'DB수량',
						type: 'txtfield',
						value: '',

						txtfield: {
							maxlength: '255',
							outlined: true,
							hideDetail: true,
							errorMessage: '',
							autocomplete: 'off',
							readonly: true,
						},
					},
				],
			},

			sweetInfo: {
				//  저장불가 팝업
				open: false,
				title: '버튼 추가 불가',
				content: ``,
				modalIcon: 'info',
				cancelBtnText: '확인',
				buttonType: 'oneBtn',
			},

			sweetDialog: {
				// 저장 완료 팝업
				open: false,
				title: '',
				content: ``,
				cancelBtnText: '확인',
				modalIcon: 'success',
			},

			first: true, // 검색을 한 상태인지 아닌지 - 검색안함:true, 검색함:false

			call_parameter: {}, // 검색 한 쿼리 값 - pagination 용
			filter_params: null, // 검색 한 쿼리 값 - pagination 용

			filterTag: {
				value: '제목',
				errorMessage: '',
				hideDetail: true,
				items: ['제목', '이름'],
				outlined: true,
			},
		}
	},
	async created() {
		this.bizTitle()
	},
	computed: {},
	methods: {
		changeTester() {
			console.log(this.filterTag.value)
		},

		async bizTitle() {
			this.$store.state.loading = true
			await this.$store.dispatch('bizTitle').then(async resData => {
				resData.data.bizTitle.businesses.sort((a, b) => {
					if (a.id < b.id) return 1
					if (a.id === b.id) return 0
					if (a.id > b.id) return -1
				})

				const bizItems = [...resData.data.bizTitle.businesses]
				if (resData.data.bizTitle.businesses.length > 0) {
					resData.data.bizTitle.businesses.unshift({
						code: 'all',
						id: 'all',
						phone: '',
						title: '전체',
					})

					this.surveySel.items = resData.data.bizTitle.businesses
					this.surveySel.value = resData.data.bizTitle.businesses[0]

					this.detail_dialog.bizItems = bizItems
					this.detail_dialog.items[0].selectBox.items = bizItems
					// await this.getTableData(resData.data.bizTitle.businesses[0])

					// 제외DB 카테고리 초기화- (detail_dialog.banDB)
					if (Array.isArray(this.detail_dialog.bizItems)) {
						let newArr = []
						for (let i = 0; i < this.detail_dialog.bizItems.length; i++) {
							const { id, code, title } = this.detail_dialog.bizItems[i]
							const newItem = { id, code, label: title, check: false }
							newArr.push(newItem)
						}
						this.detail_dialog.banDB = newArr
					}

					this.$store.state.loading = false
					// })
				} else this.$store.state.loading = false
			})
		},

		async search_reservedays() {
			this.$store.state.loading = true

			this.search_keyword = ''
			this.first = true

			await this.getTableData(this.surveySel.value)
		},

		async getTableData(val, range, filter) {
			this.dateChice = false
			this.$store.state.loading = true
			this.termStartpicker.menu = false
			this.termEndpicker.menu = false
			let headers
			// 기존 셋팅
			headers = [
				{ text: 'No.', value: 'No_index', width: '5%', sortable: false },
				{ text: '프로젝트 명', value: 'business_title', width: '15%', sortable: false },
				{ text: '마케팅 DB 명', value: 'title', width: '15%', sortable: false },
				{ text: '등록일', value: 'created_at_second', width: '13%', sortable: false },
				{ text: '추출 항목', value: 'itemList', sortable: false },
				{ text: '추출 DB 수량', value: 'number_comma', width: '12%', sortable: false },
				{
					text: '비고',
					align: 'center',
					value: 'etc_detail',
					width: '270px',
					sortable: false,
				},
			]

			let tableItems = {}
			let fiterItem = []
			let exportField = {
				'프로젝트 명': 'business_title',
				'마케팅 DB 명': 'title',
				등록일: 'created_at_second',
				'추출 항목': 'itemList',
				'추출 DB 수량': 'total',
			}
			// /마케팅 체크박스 리셋

			let data

			if (this.surveySel.value === null) {
				return (this.$store.state.loading = false)
			} else if (this.first) {
				data = {
					businessId: this.surveySel.value.id === 'all' ? undefined : String(val.id),
				}
			} else {
				data = {
					businessId: this.surveySel.value.id === 'all' ? undefined : String(val.id),
				}

				if (this.call_parameter.title_contains !== undefined) {
					data.title_contains = this.call_parameter.title_contains
				}
			}
			data['businessId_in'] = this.surveySel.items.map(el => el.id)

			// 필터 처리
			data['_where'] = []
			if (filter) {
				if (filter.title_contains !== undefined) {
					data.title_contains = filter.title_contains
				}
				if (filter._where) {
					data['_where'] = filter._where
				}
			} else {
				this.filter_params = null
			}

			// 페이지네이션 처리
			if (range) {
				data.start = range.start
				data.limit = range.limit
			} else {
				data.start = 0
				data.limit = 10
			}

			this.call_parameter = JSON.parse(JSON.stringify(data))
			await this.$store
				.dispatch('marketingDbs', data)
				.then(res => {
					let marketingDbs_items = res.data.marketingDbs
					for (let index = 0; index < marketingDbs_items.length; index++) {
						const marketingDb = marketingDbs_items[index]

						// 프로젝트명 세팅
						const marketing_business = this.surveySel.items.filter(el => String(el.id) === String(marketingDb.businessId))
						if (marketing_business.length > 0) {
							marketingDb['business_title'] = marketing_business[0].title
						}

						// 숫자 comma
						marketingDb['number_comma'] = marketingDb.total

						// No. 번호 세팅
						if (range?.itemPerPage) {
							marketingDb['No_index'] = range.itemPerPage * (range.page - 1) + index + 1
						} else {
							marketingDb['No_index'] = index + 1
						}
					}

					tableItems = {
						datatable: {
							headers: headers,
							items: res.data.marketingDbs,
							hidedefaultfooter: false,
							noweditting: '',
							title: '',
							onlyAgree: false,
							total: res.data.marketingDbsConnection.aggregate.count,
							page: range ? range.page : 1,
							itemPerPage: range ? range.itemPerPage : 10,
							pagination: range
								? {
										page: range.page,
										itemsPerPage: range.itemPerPage,
								  }
								: {
										page: 1,
										itemsPerPage: 10,
								  },
						},
						filter: filter ? this.table.filter : fiterItem,
						json_fields: exportField,
					}

					this.table = tableItems

					this.$store.state.loading = false
				})
				.catch(err => {
					console.log(err)
					this.$store.state.loading = false
				})

			// 검색 텍스트필드 blur 처리
			this.$refs.search_input.$children[0].$refs.input.blur()
		},

		// async reservedayGroups(value) {
		// 	if (value) {
		// 		let data = {
		// 			reserveday: value,
		// 		}

		// 		await this.$store.dispatch('reservedayGroups', data).then(resData2 => {
		// 			resData2.data.reservedayGroups.unshift({ title: '전체' })
		// 			this.getGroup.items = resData2.data.reservedayGroups
		// 		})
		// 	} else {
		// 		this.getGroup.items = []
		// 	}
		// },
		// 셀렉트 박스 선택된 값 테이블 적용
		async setdate() {
			let today = new Date()
			let before = new Date(today.setDate(today.getDate() - 7))
			let after = new Date(today.setDate(today.getDate() + 7))
			this.termStartpicker.date = this.$moment(before).format('YYYY-MM-DD')
			this.termEndpicker.date = this.$moment(after).format('YYYY-MM-DD')
		},

		termCustomer(val) {
			let start = this.$moment(this.termStartpicker.date).format('YYMMDD')
			let startDate = new Date(this.termStartpicker.date)
			let end = new Date(startDate.setDate(startDate.getDate() + 240))
			let endDate = this.$moment(end).format('YYMMDD')
			val = this.$moment(val).format('YYMMDD') < endDate && this.$moment(val).format('YYMMDD') >= start
			return val
		},

		async detailClick(item) {
			// 데이터 테이블 - 자세히보기 클릭

			let variable = {
				id: item.id,
			}

			this.$store.state.loading = true

			await this.$store
				.dispatch('marketingDb', variable)
				.then(async res => {
					const marketingDb = res.data.marketingDb
					const campaignCount = res.data.campaignsConnection.aggregate.count

					this.detail_dialog.type = 'edit'
					this.detail_dialog.id = marketingDb.id

					this.detail_dialog.workingBusiness = ''

					this.detail_dialog.campaigns = []

					this.detail_dialog.campaigns_added = []
					this.detail_dialog.campaign_summary = marketingDb.dbList

					const business = this.detail_dialog.items[0].selectBox.items.filter(el => String(el.id) === marketingDb.businessId)
					if (business.length > 0) this.detail_dialog.items[0].selectBox.value = business[0]
					else this.detail_dialog.items[0].selectBox.value = null

					this.detail_dialog.items[1].value = marketingDb.title // 프로젝트 // DB명

					this.detail_dialog.banDBParams = marketingDb.dbBanList

					this.detail_dialog.deleteScheduled = marketingDb.deleteScheduled
					this.detail_dialog.deleteAt = marketingDb.deleteAt

					if (campaignCount > 0 || marketingDb.deleteScheduled) {
						// 관련된 캠페인이 1개라도 있는 경우 || 삭제 예정이면 모든 인풋 disabled
						this.detail_dialog.disable_input = true
					} else {
						// 관련된 캠페인이 0개 ->  모든 인풋 입력 가능
						this.detail_dialog.disable_input = false
					}

					// 저장된 디비추출 숫자
					this.detail_dialog.items[2].value = String(marketingDb.total) // DB수량

					this.detail_dialog.campaign_summary_index = 0

					this.detail_dialog.dialog = true
				})
				.catch(() => {
					this.detail_dialog.dialog = false
					this.sweetInfo.title = '네트워크 에러'
					this.sweetInfo.content = `네트워크 에러가 발생헀습니다.\n관리자에게 문의해주세요.`
					this.sweetInfo.open = true
				})

			this.$store.state.loading = false
		},

		async pagination(item) {
			if (!this.table.datatable.pagination) {
				this.table.datatable['pagination'] = item
				this.table.datatable.options = item
			}
			if (item.page > this.table.datatable.pagination.page) {
				// 다음 페이지
				let range = {
					start: (item.page - 1) * item.itemsPerPage,
					limit: item.itemsPerPage,
					itemPerPage: item.itemsPerPage,
					page: item.page,
				}
				await this.getTableData(this.surveySel.value, range, this.filter_params)
			} else if (item.itemsPerPage !== this.table.datatable.pagination.itemsPerPage) {
				// 한페이지에 보여줄 아이템 개수 변경
				let range = {
					start: 0,
					limit: item.itemsPerPage,
					itemPerPage: item.itemsPerPage,
					page: 1,
				}
				await this.getTableData(this.surveySel.value, range, this.filter_params)
			} else if (item.page < this.table.datatable.pagination.page) {
				// 이전 페이지
				let range = {
					start: (item.page - 1) * item.itemsPerPage,
					limit: item.itemsPerPage,
					itemPerPage: item.itemsPerPage,
					page: item.page,
				}
				await this.getTableData(this.surveySel.value, range, this.filter_params)
			}
			this.table.datatable['pagination'] = JSON.parse(JSON.stringify(item))
		},
		addButtonClick() {
			// 친구톡 등록하기 버튼 클릭
			this.detail_dialog.dialog = true
			this.detail_dialog.type = 'create'
			this.detail_dialog.id = null
			this.detail_dialog.disable_input = false

			this.detail_dialog.workingBusiness = ''
			this.detail_dialog.campaigns = []
			this.detail_dialog.campaigns_added = []
			this.detail_dialog.campaign_summary = []
			this.detail_dialog.campaign_summary_index = 0

			this.detail_dialog.items[0].selectBox.value = this.detail_dialog.items[0].selectBox.items[0] // 프로젝트 기본값 세팅

			this.detail_dialog.items[1].value = '' // DB명 초기화
			this.detail_dialog.items[2].value = '' // DB수량 없음 세팅

			this.detail_dialog.deleteScheduled = false
			this.detail_dialog.deleteAt = null
		},

		validation_chceck() {
			// 저장 버튼 클릭 시 빈값 체크

			// console.log(this.$refs)
			if (!this.detail_dialog.items[1].value) {
				this.sweetInfo.title = 'DB명 미입력'
				this.sweetInfo.content = `DB명을 입력해주세요.`
				return (this.sweetInfo.open = true)
			} else if (this.detail_dialog.campaign_summary.length === 0) {
				this.sweetInfo.title = 'DB 미추출'
				this.sweetInfo.content = `추출된 DB가 없습니다.`
				return (this.sweetInfo.open = true)
			}

			if (this.detail_dialog.type === 'create') {
				this.createMarketingDb()
			} else {
				this.updateMarketingDb()
			}
		},

		/**** 마케팅 DB 생성 
 @author 전현균 
 */
		async createMarketingDb() {
			const campaign_titles = this.detail_dialog.campaign_summary.reduce((acc, cur) => {
				const campaigns = cur.campaigns.map(el => el.title)

				acc = acc.concat(campaigns)
				return acc
			}, [])

			const input = {
				businessId: String(this.detail_dialog.items[0].selectBox.value.id),
				title: this.detail_dialog.items[1].value,
				itemList: campaign_titles.join(' / '),
				total: this.detail_dialog.items[2].value ? Number(this.detail_dialog.items[2].value) : 0,
				dbList: this.detail_dialog.campaign_summary,
				leftDistribution: this.detail_dialog.items[2].value ? Number(this.detail_dialog.items[2].value) : 0,

				dbUpload: this.detail_dialog.collectDB_added, // 선택 db 추출된 것들 중 파일인 것들의 id
				dbBanUpload: this.detail_dialog.banDB_added, // 선택 db 제외된 것들 중 파일인 것들의 id
				dbBanList: this.detail_dialog.banDBParams,
			}
			this.$store.state.loading = true
			await this.$store
				.dispatch('createMarketingDb', input)
				.then(async () => {
					await this.getTableData(this.surveySel.value)
					this.detail_dialog.dialog = false
					this.sweetDialog.open = true
					this.sweetDialog.title = '마케팅 DB 생성'
					this.sweetDialog.content = '마케팅 DB를 생성하였습니다.'
					this.sweetDialog.modalIcon = 'success'
				})
				.catch(err => {
					if ({ err }.err.graphQLErrors[0].message === 'contract data error') {
						this.sweetDialog.title = '계약자 DB에러'
						this.sweetDialog.content = `계약자 DB 호출 시 오류가 발생했습니다.\n관리자에게 문의해주세요.`
						this.sweetDialog.modalIcon = 'info'
						this.sweetDialog.open = true
					} else {
						this.sweetInfo.title = '네트워크 에러'
						this.sweetInfo.content = `네트워크 에러가 발생헀습니다.\n관리자에게 문의해주세요.`
						this.sweetDialog.modalIcon = 'info'
						this.sweetInfo.open = true
					}
				})
			this.$store.state.loading = false
		},

		/**** 마케팅 DB 수정 
 @author 전현균 
*/
		async updateMarketingDb() {
			const campaign_titles = this.detail_dialog.campaign_summary.reduce((acc, cur) => {
				const campaigns = cur.campaigns.map(el => el.title)

				acc = acc.concat(campaigns)
				return acc
			}, [])

			const input = {
				id: this.detail_dialog.id,
				businessId: String(this.detail_dialog.items[0].selectBox.value.id),
				title: this.detail_dialog.items[1].value,
				itemList: campaign_titles.join(' / '),
				total: this.detail_dialog.items[2].value ? Number(this.detail_dialog.items[2].value) : 0,
				dbList: this.detail_dialog.campaign_summary,
				leftDistribution: this.detail_dialog.items[2].value ? Number(this.detail_dialog.items[2].value) : 0,

				dbUpload: this.detail_dialog.collectDB_added, // 선택 db 추출된 것들 중 파일인 것들의 id
				dbBanUpload: this.detail_dialog.banDB_added, // 선택 db 제외된 것들 중 파일인 것들의 id
				dbBanList: this.detail_dialog.banDBParams,
			}

			if (!this.$refs.DB_modal.editInited) {
				// 추출 DB 변화 없는 경우 데이터 유지를 위해 dbList,dbBanList 업데이트 하지 않음
				delete input.dbList
				delete input.dbBanList
			}

			this.$store.state.loading = true
			await this.$store
				.dispatch('updateMarketingDb', input)
				.then(async () => {
					await this.getTableData(this.surveySel.value)
					this.detail_dialog.dialog = false
					this.sweetDialog.open = true
					this.sweetDialog.title = '마케팅 DB 수정'
					this.sweetDialog.content = '마케팅 DB를 수정하였습니다.'
					this.sweetDialog.modalIcon = 'success'
				})
				.catch(err => {
					if ({ err }.err.graphQLErrors[0].message === 'contract data error') {
						this.sweetDialog.title = '계약자 DB에러'
						this.sweetDialog.content = `계약자 DB 호출 시 오류가 발생했습니다.\n관리자에게 문의해주세요.`
						this.sweetDialog.modalIcon = 'info'
						this.sweetDialog.open = true
					} else {
						this.sweetInfo.title = '네트워크 에러'
						this.sweetInfo.content = `네트워크 에러가 발생헀습니다.\n관리자에게 문의해주세요.`
						this.sweetDialog.modalIcon = 'info'
						this.sweetInfo.open = true
					}
				})
			this.$store.state.loading = false
		},

		/**** 마케팅 DB 삭제 예약 / 삭제 예약 취소
 @author 전현균 
*/
		async activeDelete() {
			this.$refs.DB_modal.deleteDialog.open = false

			this.$store.state.loading = true
			const input = {
				id: this.detail_dialog.id,
				deleteScheduled: !this.detail_dialog.deleteScheduled,
			}
			await this.$store
				.dispatch('setDeleteSchedule', input)
				.then(async () => {
					this.detail_dialog.dialog = false

					if (!this.detail_dialog.deleteScheduled) {
						this.sweetDialog.title = '마케팅DB 삭제'
						this.sweetDialog.content = '마케팅DB 삭제 예약하였습니다.'
					} else {
						this.sweetDialog.title = '마케팅 DB 삭제 예약 취소'
						this.sweetDialog.content = '마케팅 DB 삭제 예약을 취소하였습니다'
					}
					this.sweetDialog.modalIcon = 'success'
					this.sweetDialog.open = true
				})
				.catch(() => {
					this.sweetInfo.title = '네트워크 에러'
					this.sweetInfo.content = `네트워크 에러가 발생헀습니다.\n관리자에게 문의해주세요.`
					this.sweetDialog.modalIcon = 'info'
					this.sweetInfo.open = true
				})

			this.$store.state.loading = false
		},

		open_disable_dialog(data) {
			// 불가 팝업 열기

			this.sweetInfo.title = data.title
			this.sweetInfo.content = data.content
			this.sweetInfo.open = true
		},

		/**** DB 상담사 회원가입용 프로젝트 코드 복사 버튼
 @author 전현균
 */
		async codeCopy(item) {
			try {
				this.$store.state.loading = true

				// API 호출
				const response = await this.$store.dispatch('businessCode', {
					id: String(item.businessId),
				})

				if (!response.data?.business?.code) {
					throw new Error('비즈니스 코드를 찾을 수 없습니다.')
				}

				const codeToShare = response.data.business.code

				//  복사기능 주석 처리 ==============================
				// // 모던 브라우저 및 iOS/iPadOS 13+ 지원
				// if (navigator.clipboard && window.isSecureContext) {
				// 	await navigator.clipboard.writeText(codeToShare)
				// 	this.showSuccessMessage(codeToShare)
				// 	return
				// }

				// // iOS/iPadOS용 대체 방법
				// if (navigator.userAgent.match(/ipad|iphone/i)) {
				// 	this.showSuccessMessage(codeToShare)
				// }

				// 복사기능 없이 바로 팝업 안에서 복사하도록 바로 팝업 열기 ==========
				this.showSuccessMessage(codeToShare)
			} catch (err) {
				this.showErrorMessage(err)
			} finally {
				this.$store.state.loading = false
			}
		},

		// 성공 메시지 표시
		showSuccessMessage(code) {
			this.sweetDialog.open = true
			this.sweetDialog.title = '코드 복사'
			this.sweetDialog.content = `프로젝트 코드 : ${code}\nctrl + c로 코드를 복사하세요.`
			this.sweetDialog.modalIcon = 'success'
		},

		// 에러 메시지 표시
		showErrorMessage(err) {
			this.sweetDialog.open = true
			this.sweetDialog.title = '네트워크 에러'
			this.sweetDialog.content = '네트워크 에러가 발생했습니다.\n관리자에게 문의해주세요.' + JSON.stringify(err)
			this.sweetDialog.modalIcon = 'info'
		},
	},
}
</script>
<style lang="scss" scoped>
.wrapper {
	margin: 0px !important;
}
</style>
<style lang="scss">
.surveyChoice {
	font-size: 18px;
	font-weight: bold;
	margin-right: 10px;
}

.surveyTitle {
	font-size: 18px;
	font-weight: bold;
	margin-top: 20px;
}

.filterFlex {
	padding: 20px 20px 58px 0px;
}

.filterBox {
	background: white;
	height: 100%;
	border: 2px solid #e1e1e1;
	border-radius: 5px;
}

.filterHead {
	margin: 0px !important;
	padding: 14px;
	border-bottom: 1.5px solid #e1e1e1;
}

.filterLayout {
	padding: 14.8px;
	// border-bottom: 1.5px solid #e1e1e1;`
}

.checkboxLinebreak {
	line-break: anywhere;
}

.qaLists-dialog {
	opacity: 0;
	width: 100%;
	background-color: white !important;
}

.search_box_type {
	width: auto !important;
	height: 26px !important;
	margin-right: 10px !important;
	padding: 0 10px !important;
	font-size: 13px;
	font-weight: bold;

	.v-btn__content {
		color: #fff;
	}
}

//검색 박스
.search_box_type {
	width: 193px;
	margin-left: 10px;

	div {
		div {
			.v-input__slot {
				min-height: 26px !important;
				height: 26px;
				padding: 0 10px !important;
			}
		}
	}
}

.search_select_type {
	min-height: 26px !important;
	height: 26px !important;
	width: 400px;
	max-width: 400px;

	div {
		div {
			div {
				div {
					.v-input__append-inner {
						margin-top: 1px !important;
					}
				}
			}
		}
	}
}

.customer-management-text {
	font-size: 12px;
	font-weight: bold;
	width: auto;
	color: #204037;
}

.customer-management-btn {
	box-shadow: none;
	border: 1px solid #c5c3d5;
	width: 88px;
	height: 26px !important;
	background-color: #f3f3ff !important;

	.v-btn__content {
		color: #323153;
		font-size: 13px;
	}
}
</style>
